import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock } from "@phosphor-icons/react";
import { Eyebrow } from "../components/Motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState("");
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.get(`${API}/inquiries`, { headers: { "X-Admin-Key": key } });
      setRows(res.data);
      toast.success(`Loaded ${res.data.length} inquiries.`);
    } catch (err) {
      toast.error("Invalid passcode.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-36 sm:pt-44 min-h-screen">
      <section className="max-w-[1440px] mx-auto px-5 sm:px-8">
        <Eyebrow>Owner area</Eyebrow>
        <h1 className="font-display font-light text-5xl sm:text-6xl text-[color:var(--text)] mt-4">Inquiries</h1>

        <form onSubmit={load} className="flex flex-wrap items-end gap-4 mt-10 max-w-lg">
          <div className="flex-1 min-w-[220px]">
            <label className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-[color:var(--muted)] flex items-center gap-2"><Lock size={12} /> Passcode</label>
            <input
              data-testid="admin-key-input"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              className="w-full bg-transparent border-b border-[color:var(--border)] py-3 text-[color:var(--text)] focus:border-[color:var(--gold)] focus:outline-none transition-colors"
              placeholder="Enter passcode"
            />
          </div>
          <button data-testid="admin-load-button" disabled={loading} className="rounded-full bg-[color:var(--gold)] px-7 py-3 text-[#0b0710] font-medium hover:bg-[color:var(--gold-light)] transition-colors disabled:opacity-60">
            {loading ? "Loading…" : "View"}
          </button>
        </form>
      </section>

      <section className="max-w-[1440px] mx-auto px-5 sm:px-8 py-16">
        {rows && rows.length === 0 && <p className="text-[color:var(--text-2)]">No inquiries yet.</p>}
        {rows && rows.length > 0 && (
          <div className="space-y-4" data-testid="admin-inquiries-list">
            {rows.map((r) => (
              <div key={r.id} className="border hairline bg-[color:var(--surface)] p-6 sm:p-8">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <h3 className="font-display text-2xl text-[color:var(--text)]">{r.name}</h3>
                  <span className="font-mono-x text-xs text-[color:var(--muted)]">{new Date(r.created_at).toLocaleString()}</span>
                </div>
                <div className="flex flex-wrap gap-x-8 gap-y-1 mt-2 text-sm text-[color:var(--text-2)]">
                  <span>{r.email}</span>
                  {r.phone && <span>{r.phone}</span>}
                  {r.service && <span className="text-[color:var(--gold)]">{r.service}</span>}
                </div>
                <p className="text-[color:var(--text)] mt-4 leading-relaxed whitespace-pre-wrap">{r.message}</p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
